<div class="indicators-page">
  <div class="indicators-page__content">
    <div class="title-container no-print">
      <h1 class="page-title">Indicators</h1>

      <div class="indicator-actions-row">
        <social-buttons class="social-buttons"></social-buttons>
        <app-indicator-buttons
          class="action-buttons"
          [group]="group"
          [short]="short"
          [breakdown]="breakdown"
        ></app-indicator-buttons>
      </div>
    </div>

    @if (requestState === 'loading') {
      <div class="d-flex justify-content-center">
        <app-loader></app-loader>
      </div>
    } @else {

      @if (requestState === 'error') {
        <div class="alert alert-danger">{{'indicators.error.generic' | translate}}</div>
      } @else {

        <div class="animated fadeIn indicator-filters">
          <div class="indicator-filter-row">
            <mat-form-field class="w-100 indicator-filter-field" floatLabel="always" subscriptSizing="dynamic">
              <mat-label>{{'indicators.group' | translate}}</mat-label>
              <mat-select [(ngModel)]="group" (ngModelChange)="updateShorts()" class="w-100"
                          aria-haspopup="dialog"
                          role="listbox"
                          saveInputValue="group">
                @for (option of groups; track option) {
                  <mat-option [value]="option">
                    {{option}}
                  </mat-option>
                }
              </mat-select>
              @if (groups.length <= 0) {
                <mat-option [disabled]="true">No data</mat-option>
              }
            </mat-form-field>
          </div>

          <div class="indicator-filter-row">
            @if (group) {
              <mat-form-field class="w-100 indicator-filter-field" floatLabel="always" subscriptSizing="dynamic">
                <mat-label>{{'indicators.short' | translate}}</mat-label>
                <mat-select [(ngModel)]="short" (ngModelChange)="updateBreakdown()" class="w-100"
                            aria-haspopup="dialog"
                            role="listbox"
                            saveInputValue="short">
                  @for (option of shorts; track option) {
                    <mat-option [value]="option">
                      {{option}}
                    </mat-option>
                  }
                </mat-select>
                @if (shorts.length <= 0) {
                  <mat-option [disabled]="true">No data</mat-option>
                }
              </mat-form-field>
            }
          </div>

          <div class="indicator-filter-row">
            @if (short) {
              <mat-form-field class="w-100 indicator-filter-field" floatLabel="always" subscriptSizing="dynamic">
                <mat-label>{{'indicators.breakdown' | translate}}</mat-label>
                <mat-select [(ngModel)]="breakdown" (ngModelChange)="updateUnit()" class="w-100"
                            aria-haspopup="dialog"
                            role="listbox"
                            saveInputValue="breakdown">
                  @for (option of breakdowns; track option) {
                    <mat-option [value]="option">
                      {{option}}
                    </mat-option>
                  }
                </mat-select>
                @if (breakdowns.length <= 0) {
                  <mat-option [disabled]="true">No data</mat-option>
                }
              </mat-form-field>
            }
          </div>

          <input type="hidden" [(ngModel)]="unit" saveInputValue="unit"/>

          @if (indicator) {
            <app-indicator-values-component
              [indicator]="indicator"
            ></app-indicator-values-component>
          } @else {
            <div class="d-flex align-items-center justify-content-center pt-5 pb-5 border">
              <fa-icon [icon]="icons.noSelection" size="2x"></fa-icon>
              <div class="ml-3">Make a selection</div>
            </div>
          }

          @if (indicator) {
            <div class="indicator-details-block">
              <app-indicator-details-component [indicator]="indicator"></app-indicator-details-component>
            </div>
          }
        </div>
      }
    }
  </div>
</div>
